<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>海關研學</el-breadcrumb-item>
                <el-breadcrumb-item>對比研究列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



      <div class="content">

        <div>
          <div class="data-box">
            

            <div class="tab-data" style="margin-top:20px;">

              <template>
                <div style="min-height:500px;">
                  <el-table
                  ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  :row-style="tableRowStyle"
                  :header-cell-style="tableHeaderColor"

                  style="margin-left:50px; width: 1100px;">
                  <el-table-column
                    type="index"
                    label="序號"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="comparetitle"
                    label="標題"
                    width="650">
                  </el-table-column>
                  <el-table-column
                    prop="comtime"
                    label="時間"
                    width="200">
                  </el-table-column>
                  <el-table-column
                    prop=""
                    label="操作"
                    width="150">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="managecom(scope.row.ID)">管理</el-button>
                      <el-button type="text" size="small" @click="readcom(scope.row.comids)">查看</el-button>
                    </template>
                  </el-table-column>
                </el-table>

                </div>
                

                


              </template>

            </div>

          </div>
        </div>

      </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
        username:"",
        userid:"",
        tableData:[],
        ispage:true,
        currentpage:1,
        pagesize:20,
        totalcount:10,
        pictLoading:false,
      totalData:'99999',
    };
  },
  methods: {
      //查看
    readcom(mids){
        this.$router.push({ path: "/hgresearch_compare",query:{ids:mids}});

    },
    //管理
    managecom(mid){
        this.$router.push({ path: "/hghome_mine",query:{id:1}});

    },


    //点击搜索按钮
    btnsearch(){

    },
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
    //设置表格行的样式
   tableRowStyle({row,rowIndex}){
     let st;
     if(rowIndex%2==1){
       st={
         'background-color':'#f0f0f0',
       };

     }
     return st;
     },
      //设置表头行的样式
    tableHeaderColor({row,column,rowIndex,columnIndex}){
        return 'background-color:#d4c9bc;color:#9a7455;font-wight:500;font-size:16px;text-align:center;height: 50px';
    },
  },
  created() {
    //获取当前条目ID号
    //let id = this.$route.params.id;
    this.username=window.sessionStorage.getItem('hguser');
    this.userid=window.sessionStorage.getItem('hguid');
    this.userid=2;
    this.$http
      .get(`${this.$store.state.baseurl}/api/hgresearch_compare/getcomparelist?username=`+this.username+"&userid="+this.userid)
      .then((res) => {
        const json = res.data;
        const obj = JSON.parse(json);
        this.tableData=obj.data;
        //console.log(this.tableData);
      });
  },
};
</script>



<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.my-table{
  margin-left: auto;
  margin-right: auto;
  .my-tbody{
    display: table-row-group;
    vertical-align: middle;
    width: 1000px;
    
    tr {
        display: table-row;
        vertical-align: inherit;
        th {
          display: table-cell;
          vertical-align: inherit;
          font-weight: bold;
          text-align: left;
          height: 50px;
          border: none;
          background-color: #d4c9bc;
      }
        td {
          display: table-cell;
          vertical-align: inherit;
          text-align: left;
          height:80px;
      }
    }

  }
}





</style>